var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 125",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95 38.831C95 51.1897 88.5494 72.5028 71.1081 80.8239C69.4705 81.6051 68.4457 79.6039 69.8095 78.413C81.7181 68.015 85.7365 57.2426 75 58.662C63.9543 58.662 55 49.7834 55 38.831C55 27.8786 63.9543 19 75 19C86.0457 19 95 27.8786 95 38.831Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 38.831C45 51.1897 38.5494 72.5028 21.1081 80.8239C19.4705 81.6051 18.4457 79.6039 19.8095 78.413C31.7181 68.015 35.7365 57.2426 25 58.662C13.9543 58.662 5 49.7834 5 38.831C5 27.8786 13.9543 19 25 19C36.0457 19 45 27.8786 45 38.831Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.f372004e5d2b456fe3192ad865a2d268.svg";
export { ForwardRef as ReactComponent };